import * as React from 'react';
import * as styles from './styles.css';
import { ICardBanner } from '../../common/repositories/job-vacancies-backend/entities/banner/CardBanner';
import { Typography } from '../../components/Typography';
import { Link } from '../../components/Link';
import { ArrowUpRight12 } from '../../components/Icons';
import cn from 'clsx';
import { TTextLevel } from '../../types/typography';
import { sendClickBannerEvent } from '../../utils/analytics/events/clickBanner';
import { useDeviceType } from '@cian/ui-kit';

interface IBannerProps {
  content: ICardBanner;
  withMaxWidth?: boolean;
}

export const Banner: React.FC<IBannerProps> = ({ content, withMaxWidth = false }) => {
  const deviceType = useDeviceType();

  const handleLinkClick = () => {
    sendClickBannerEvent({ deviceType, url: content.link.href });
  };

  return (
    <div
      className={cn(styles['container'], withMaxWidth && styles['with-max-width'])}
      style={{ backgroundImage: `url(${content.background.url})` }}
    >
      <div className={styles['main-content']}>
        <div className={styles['title']}>
          <Typography.Title level={content.title.style.level as TTextLevel} color="currentColor">
            {content.title.text}
          </Typography.Title>
        </div>
        <div className={styles['description']}>
          <Typography.Text level={content.description.style.level as TTextLevel} color="currentColor">
            {content.description.text}
          </Typography.Text>
        </div>
      </div>
      <div className={styles['link']}>
        <Link
          onClick={handleLinkClick}
          href={content.link.href}
          text={content.link.text}
          color="white"
          afterIcon={<ArrowUpRight12 color="currentColor" />}
        />
      </div>
    </div>
  );
};
